<div class="d-flex justify-content-end pagination-content">
<nav *ngIf="articleList && articleList.length > 0">
    <ul class="pagination rvh-pagination">
        <li class="page-item" [class.disabled]="currentPage === 1">
            <a [attr.href]="pageHref(currentPage - 1)" (click)="prevPage($event)"
                (keydown.space)="prevPage($event)" title="Previous"
                class="page-link primary-color">Previous</a>
        </li>
        <li class="page-item" [class.active]="num === currentPage" *ngFor="let num of pageNumbers">
            <a *ngIf="num !== '...'; else ellipsis" [attr.href]="pageHref(num)" (click)="changePage(num, $event)"
                (keydown.space)="changePage(num, $event)" title="{{num}}"
                [attr.aria-current]="num === currentPage ? 'page' : null"
                class="page-link black-label">{{num}}</a>
            <ng-template #ellipsis><span class="page-link black-label">{{num}}</span></ng-template>
        </li>
        <li class="page-item" [class.disabled]="currentPage === totalPages">
            <a [attr.href]="pageHref(currentPage + 1)" (click)="nextPage($event)"
                (keydown.space)="nextPage($event)" title="Next"
                class="page-link primary-color">Next</a>
        </li>
    </ul>
</nav>
</div>
